// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"ff8fc0dd","332":"0b0442da","596":"7baaaa25","646":"a143f4f8","705":"cad98b0b","787":"9e24b57a","946":"40761b29"}[chunkId] + ".chunk.js";
};